import { useState } from "react";

import { Button, CircularProgress, Stack, Typography } from "@mui/material";

import { ErrorTypography } from "components/ErrorTypography";
import {
  getPhoneNumberError,
  PhoneNumberField,
} from "components/PhoneNumberField";

import type { WriterComponentState } from "hooks/useWriterComponentState";

interface Props {
  phoneNumber: string;
  onPhoneNumberChange: (value: string) => void;
  onSendCode: VoidFunction;
  onCancel: VoidFunction;
  sendCodeWriter: WriterComponentState;
}

export function PhoneEntryStep(props: Props) {
  const {
    phoneNumber,
    onPhoneNumberChange,
    onSendCode,
    onCancel,
    sendCodeWriter,
  } = props;

  const [validationError, setValidationError] = useState<string | null>(null);
  const phoneNumberError = getPhoneNumberError(phoneNumber);

  const handleBlur = () => setValidationError(phoneNumberError);

  return (
    <Stack spacing={2}>
      <Typography variant="body2" color="text.secondary">
        Enter your mobile phone number to receive verification codes.
      </Typography>
      <PhoneNumberField
        label="Phone Number"
        value={phoneNumber}
        onChange={(value) => {
          onPhoneNumberChange(value);
          setValidationError(null);
        }}
        onBlur={handleBlur}
        error={validationError != null}
        helperText={validationError ?? undefined}
        fullWidth
        autoFocus
      />
      <ErrorTypography error={sendCodeWriter.error} />
      <Stack direction="row" justifyContent="flex-end" spacing={1}>
        <Button variant="text" onClick={onCancel}>
          Cancel
        </Button>
        {sendCodeWriter.loading ? (
          <CircularProgress size={36} />
        ) : (
          <Button
            variant="contained"
            color="success"
            onClick={onSendCode}
            disabled={!phoneNumber || phoneNumberError != null}
          >
            Send Verification Code
          </Button>
        )}
      </Stack>
    </Stack>
  );
}
